<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>Battleships of the World</title>
<link href="../style/9781473871489.css" rel="stylesheet" type="text/css"/>
<h1 class="chapname1_t">Contents</h1>
<h2 class="toc_chap1"><a href="#/xhtml/06_intro">Introduction</a></h2>
<h2 class="toc_chap"><a href="#/xhtml/07_Chapter_1"><span class="tocn">Chapter 1</span> The Age of Innovation 1820–1870</a></h2>
<h2 class="toc_chap"><span href="#/xhtml/08_Chapter_2" title="Link target outside of Sample"><span class="tocn">Chapter 2</span> The Age of Experiment: 1870–1890</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/09_Chapter_3" title="Link target outside of Sample"><span class="tocn">Chapter 3</span> The Two Power Standard</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/10_Chapter_4" title="Link target outside of Sample"><span class="tocn">Chapter 4</span> The Age of the Dreadnought 1906–1908</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/11_Chapter_5" title="Link target outside of Sample"><span class="tocn">Chapter 5</span> The Naval Race 1908–1914</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/12_Chapter_6" title="Link target outside of Sample"><span class="tocn">Chapter 6</span> Dreadnoughts at War – 1914–1918</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/13_Chapter_7" title="Link target outside of Sample"><span class="tocn">Chapter 7</span> Pre-dreadnoughts in the First World War</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/14_Chapter_8" title="Link target outside of Sample"><span class="tocn">Chapter 8</span> The Treaty of Versailles and the Washington Naval Treaty</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/15_Chapter_9" title="Link target outside of Sample"><span class="tocn">Chapter 9</span> Rearmament</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/16_Chapter_10" title="Link target outside of Sample"><span class="tocn">Chapter 10</span> Battle Fleets in Action, 1939–45 – the North Sea and the Atlantic</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/17_Chapter_11" title="Link target outside of Sample"><span class="tocn">Chapter 11</span> War in the Mediterranean</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/18_Chapter_12" title="Link target outside of Sample"><span class="tocn">Chapter 12</span> Battleships in the Pacific</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/19_Chapter_13" title="Link target outside of Sample"><span class="tocn">Chapter 13</span> The End of the Battleship Era</span></h2>
<h2 class="toc_chap1"><span href="#/xhtml/bibliography" title="Link target outside of Sample">Bibliography</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_toc.vue?ddf65210